import premierLeagueCrest from '../images/Premier_League-Logo.wine.svg';
import laLigaCrest from '../images/leagues/la-liga.svg';
import mlsCrest from '../images/leagues/mls.svg';
import nationsLeagueCrest from '../images/leagues/uefa-nations-league.png';
import championsLeagueCrest from '../images/leagues/uefa-champions-league.jpg';
import { sortCompetitions } from './CompetitionFilter';

// Crests, keyed by the competition names the feed actually returns (ids 1, 218, 163,
// 2212 and 2219). A league we have no crest for still gets a row, just without the
// badge. `fit` picks how a crest sits in the badge slot.
export const LEAGUE_CRESTS = {
    'Premier League': { crest: premierLeagueCrest, fit: 'fill' },
    'La Liga': { crest: laLigaCrest },
    'Major League Soccer': { crest: mlsCrest },
    'UEFA Champions League': { crest: championsLeagueCrest },
    'UEFA Nations League': { crest: nationsLeagueCrest, fit: 'cover' },
};

// One entry per league with an upcoming fixture in the landing feed, pointing at the
// public preview page pre-filtered to that league (?competition=<id>, the same URL state
// the dashboard and /teams-listing use) so it opens on that league's chip rather than
// "All". sortCompetitions applies the shared chip order, so Premier League leads.
export const buildLeagueLinks = (fixtures, competitionDisplayName) => {
    const byCompetition = new Map();

    fixtures
        .filter((fixture) => fixture?.status !== 'finished'
            && fixture?.match_date
            && new Date(fixture.match_date).getTime() > Date.now())
        .sort((a, b) => new Date(a.match_date) - new Date(b.match_date))
        .forEach((fixture) => {
            const competition = fixture.competition;
            const season_name = competitionDisplayName(competition);
            if (competition?.id == null || !season_name || byCompetition.has(competition.id)) return;

            byCompetition.set(competition.id, {
                id: competition.id,
                season_name,
                to: `/fixtures-preview?competition=${competition.id}`,
                ...LEAGUE_CRESTS[season_name],
            });
        });

    return sortCompetitions(Array.from(byCompetition.values()));
};
